import { useNavigate, useLocation } from 'react-router-dom';
import './Menu.css';
import { useState, useEffect } from 'react';

const Menu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const onNavigate = (url: string) => {
    setMenuOpen(false);
    navigate(url);
  };

  const toggleMenu = () => setMenuOpen((v) => !v);

  // cerrar menú si cambias de ruta
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // cerrar menú si se cambia a vista de escritorio
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 650) setMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className='container'>
      <div className="logo">
        <img src="/Image/logo.png" alt="logo del abuelo wine" onClick={() => onNavigate('/')} />
      </div>

      <div className={`menu ${menuOpen ? 'open' : ''}`}>
        <div className="link" onClick={() => onNavigate('/')}>Nosotros</div>
        <div className="link" onClick={() => onNavigate('/wines')}>Vinos</div>
        <div className="link" onClick={() => onNavigate('/contact')}>Contacto</div>
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        <img src="/Image/amburguer.png" alt="menu hamburguesa" />
      </div>
    </div>
  );
};

export default Menu;
